<template>
  <div class="modal select-none fixed pin z-50 overflow-x-hidden overflow-y-auto" style="z-index: 1000">
    <div class="relative mx-auto flex justify-center z-20 py-view">
      <slot />
    </div>
  </div>
</template>

<script>
export default {}
</script>
